import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  saving: false,
});

const marketingPromoModule = {
  namespaced: true,
  state: initState(),
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },

  actions: {
    async getMarketingPromoSettings({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: { key: "deposit-match-bonus-expired-days" },
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    async updateMarketingPromoSettings({ commit }, value) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          key: "deposit-match-bonus-expired-days",
          value,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default marketingPromoModule;
